<template>
    <tr>
        <td class="no-wrap-text text-center">
            <strong class="month">{{ transaction.date|formatDate('DD/MM HH:mm') }}</strong><br>
        </td>
        <td class="monospaceText text-right">{{ transaction.amount|roundNumber }}</td>
        <td>{{ transaction.type }}</td>
        <!--<td><span v-if="transaction.account != null">{{ transaction.account.job.customer.lastname }}</span> </td>-->
        <td><span v-if="transaction.account != null">{{ transaction.account.job.id|TruncateJobNumber }}</span> </td>
        <td><span v-if="transaction.account != null">{{ transaction.account.job.job_type.job_type_name }}</span> </td>
        <td class="no-wrap-text text-center"><span v-if="transaction.account != null">{{ transaction.account.job.date_job_start|formatDate('DD/MM HH:mm') }}</span> </td>
        <td>
            {{'Transaction'}} : {{ transaction.method }}<br>
            <div v-html="transaction.comment" class="comment-transfer"></div>
        </td>
        <td v-if="!isNoviceWorker" class="monospaceText text-right">{{ supplement }}</td>
    </tr>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        props: {
            transaction: Object,
            isNoviceWorker: false,
        },
        computed: {
            supplement() {
                if (this.transaction.account === null) {
                    return null;
                }
                return this.transaction.account.job.supplement;
            },
        },
        filters: {
            formatDate(value, format) {
                if (value) {
                    if (format === undefined) {
                        format = 'YYYY-MM-DD HH:mm';
                    }
                    return moment(String(value)).format(format)
                }
            },
            /* @return Number */
            keep2Decimals(number) {
                //return number.toFixed(2);
				return number !== null ? number.toFixed(2) : number ;
            },
            TruncateJobNumber(value) {
                return value.toString().substr(2, value.toString().length);
            },
            roundNumber(number) {
              return number !== null ? Math.round(number) : number ;
              //return number.toFixed(2);
            },
        },
    }
</script>

<style>
    .no-wrap-text {
        white-space: nowrap;
    }
    .month {
        color: #cdcdcd;
        text-transform: capitalize;
    }
    .comment-transfer {
        width: 250px;
    }
</style>
